import { PaletteOptions } from '@mui/material';
import { ThemeOption } from '.';
/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */
export default function themePalette(theme: ThemeOption): PaletteOptions {
    const dark = theme.mode === 'dark';
    return {
        mode: theme.mode,
        common: {
            black: '#000000'
        },
        primary: {
            light: theme.colors.primaryLight,
            main: theme.colors.primaryMain,
            dark: theme.colors.primaryDark,
            200: theme.colors.primary200,
            800: theme.colors.primary800
        },
        secondary: {
            light: theme.colors.secondaryLight,
            main: theme.colors.secondaryMain,
            dark: theme.colors.secondaryDark,
            200: theme.colors.secondary200,
            800: theme.colors.secondary800,
            contrastText: theme.colors.contrastText,
        },
        error: {
            light: theme.colors.errorLight,
            main: theme.colors.errorMain,
            dark: theme.colors.errorDark
        },
        warning: {
            light: theme.colors.orangeLight,
            main: theme.colors.orangeMain,
            dark: theme.colors.orangeDark
        },
        success: {
            light: theme.colors.successLight,
            200: theme.colors.success200,
            main: theme.colors.successMain,
            dark: theme.colors.successDark
        },
        grey: {
            50: theme.colors.grey50,
            100: theme.colors.grey100,
            500: theme.colors.grey500,
            600: theme.colors.grey600,
            700: theme.colors.grey700,
            900: theme.colors.grey900
        },
        text: {
            primary: dark ? theme.darkTextPrimary : theme.TextPrimary,
            secondary: dark ? theme.darkTextSecondary : theme.textSecondary,
        },
        background: {
            paper: dark ? theme.paperDark : theme.paper,
            default: dark ? theme.backgroundDark : theme.backgroundDefault
        }
    };
}
